import {createSelector} from 'reselect';

export const getAppliedBaselineDate = createSelector(
  (state) => state.tasks.baseline.appliedBaselineDate,
  (date) => date,
);
